import * as React from 'react';
import {StyleSheet, View, PixelRatio} from 'react-native';
import type {BundleType} from 'src/types/TransactionDetail';
import AVText from '../AVText';
import Icon from 'react-native-vector-icons/FontAwesome5Pro';
import AVFormattedCurrency from '../AVFormattedCurrency';
import Styles from '../../Styles';
import Localized from 'src/constants/AppStrings';
import SwipeableRow from '../DeleteSwipeableRow';
import Button from '../Button';
type CartBundleProps = {
  trashClick?: (lineNumbers: Array<number>) => void;
  bundle: BundleType;
};

class CartBundle extends React.Component<CartBundleProps> {
  constructor(props: CartBundleProps) {
    super(props);
    this.trashClick = this.trashClick.bind(this);
  }

  trashClick(lineNumbers: Array<number>) {
    if (this.props.trashClick) {
      this.props.trashClick(lineNumbers);
    }
  }

  render() {
    const totalDiscount = this.props.bundle.items.reduce((prev, cur) => {
      if (cur.Discount) {
        return prev + parseFloat(cur.Discount) * 1;
      } else {
        return prev;
      }
    }, 0);
    const totalPrice = this.props.bundle.items.reduce((prev, cur) => {
      const price = parseFloat(cur.Price);
      let modifierPrice = 0;

      if (cur.Modifiers) {
        modifierPrice = cur.Modifiers.reduce((prevModifierPrice, modifier) => {
          if (modifier.Price) {
            return prevModifierPrice + modifier.Price;
          } else {
            return prevModifierPrice;
          }
        }, 0);
      }

      return prev + price + modifierPrice;
    }, 0);
    const discountRow = (
      <View style={[styles.discountRow]}>
        <AVText style={styles.discountText}>
          {Localized.Labels.discount} (
          <AVFormattedCurrency
            accessibilityLabel="discount"
            value={totalDiscount}
          />
          )
        </AVText>
      </View>
    );
    const items = this.props.bundle.items.map((item) => {
      const icon = (
        <AVText>
          <Icon name="times" size={Styles.Fonts.f1} style={styles.icon} />
          {` ${item.Description || ''}`}
        </AVText>
      );
      return (
        <Button
          overrideStyles={[styles.categoryButton]}
          onPress={() => this.trashClick([item.LineNumber || -1])}
          overrideTextStyles={styles.categoryText}
          text={icon}
          accessibilityLabel={item.Description}
        />
      );
    });
    return (
      <SwipeableRow
        onDeletePressed={() =>
          this.trashClick(
            this.props.bundle.items.map((item) => item.LineNumber || -1),
          )
        }
        type="remove"
      >
        <View style={styles.container}>
          <View style={styles.bundle}>
            <View style={styles.mainRow}>
              <View style={styles.rowContainer}>
                <AVText numberOfLines={1} style={styles.description}>
                  {this.props.bundle.title}
                </AVText>
                <AVFormattedCurrency
                  style={styles.amount}
                  value={totalPrice}
                  accessibilityLabel="itemPrice"
                />
              </View>
              {discountRow}
            </View>
          </View>
          {items}
        </View>
      </SwipeableRow>
    );
  }
}

const styles = StyleSheet.create({
  amount: {
    color: Styles.darkColor,
    fontSize: Styles.Fonts.f1,
  },
  bundle: {
    alignItems: 'center',
    alignSelf: 'stretch',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: Styles.Spacing.m1,
  },
  container: {
    alignSelf: 'stretch',
    marginBottom: Styles.Spacing.m1,
    marginTop: Styles.Spacing.m2,
    marginRight: Styles.Spacing.m2,
  },
  description: {
    color: Styles.darkColor,
    fontSize: Styles.Fonts.f2,
    fontWeight: '300',
    marginRight: Styles.Spacing.m2,
    flex: 1,
  },
  discountText: {
    color: Styles.auxColor,
    fontSize: Styles.Fonts.f0,
    alignSelf: 'flex-end',
  },
  icon: {
    marginRight: Styles.Spacing.m2,
  },
  item: {
    backgroundColor: Styles.primaryColor,
    borderRadius: Styles.Spacing.m1,
    flexDirection: 'row',
    marginRight: Styles.Spacing.m1,
    padding: Styles.Spacing.m1,
  },
  itemText: {
    color: Styles.white,
  },
  items: {
    flexDirection: 'row',
  },
  mainRow: {
    flex: 1,
  },
  rowContainer: {
    alignItems: 'center',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  discountRow: {
    alignItems: 'flex-end',
  },
  smallIcon: {
    height: 20,
    marginTop: -2.5,
    width: 20,
  },
  categoryButton: {
    backgroundColor: Styles.auxColor,
    borderRadius: PixelRatio.roundToNearestPixel(Styles.Spacing.m2),
    height: undefined,
    marginRight: Styles.Spacing.m1,
    padding: Styles.Spacing.m2,
    paddingHorizontal: Styles.Spacing.m3,
    marginBottom: Styles.Spacing.m2,
    alignSelf: 'flex-start',
  },
  categoryText: {
    fontSize: Styles.Fonts.f1,
    fontWeight: undefined,
  },
});
export default CartBundle;
